// See https://devhints.io/umdjs
;

(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(factory);
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.jsonLogicExtensions = factory();
  }
})(this, function () {
  function normalizeDate(input) {
    var split = input.split(',');
    var timestamp = parseInt(split[0]);
    var offset = parseInt(split[1]);
    return new Date(timestamp - offset);
  }

  var extensions = {};
  extensions.__normalizeDate = normalizeDate;
  /**
   * Returns true if date A comes after date B.
   * Dates are represented using number of milliseconds since Jan 1, 1970 GMT.
   */

  extensions.__isDateAfter = function (a, b) {
    if (!a || !b) {
      return false;
    }

    a = normalizeDate(a);
    b = normalizeDate(b);
    return a.getTime() > b.getTime();
  };
  /**
   * Returns true if date A comes before date B.
   * Dates are represented using number of milliseconds since Jan 1, 1970 GMT.
   */


  extensions.__isDateBefore = function (a, b) {
    if (!a || !b) {
      return false;
    }

    a = normalizeDate(a);
    b = normalizeDate(b);
    return a.getTime() < b.getTime();
  };
  /**
   * Returns true if the dates A and B are equal. Ignores seconds and milliseconds.
   * Dates are represented using number of milliseconds since Jan 1, 1970 GMT.
   */


  extensions.__isDateEqual = function (a, b) {
    if (!a || !b) {
      return false;
    }

    a = normalizeDate(a);
    b = normalizeDate(b);
    return a.getUTCFullYear() === b.getUTCFullYear() && a.getUTCMonth() === b.getUTCMonth() && a.getUTCDate() === b.getUTCDate() && a.getUTCHours() === b.getUTCHours() && a.getUTCMinutes() === b.getUTCMinutes();
  };
  /**
   * Returns true if the time of day denoted by date A is greater than that of date B. Seconds and milliseconds are
   * ignored.
   * Dates are represented using number of milliseconds since Jan 1, 1970 GMT.
   */


  extensions.__isTimeAfter = function (a, b) {
    if (!a || !b) {
      return false;
    }

    a = normalizeDate(a);
    b = normalizeDate(b);
    return a.getUTCHours() > b.getUTCHours() || a.getUTCHours() === b.getUTCHours() && a.getUTCMinutes() > b.getUTCMinutes();
  };
  /**
   * Returns true if the time of day denoted by date A is less than that of date B. Seconds and milliseconds are
   * ignored.
   * Dates are represented using number of milliseconds since Jan 1, 1970 GMT.
   */


  extensions.__isTimeBefore = function (a, b) {
    if (!a || !b) {
      return false;
    }

    a = normalizeDate(a);
    b = normalizeDate(b);
    return a.getUTCHours() < b.getUTCHours() || a.getUTCHours() === b.getUTCHours() && a.getUTCMinutes() < b.getUTCMinutes();
  };
  /**
   * Returns true if the time of day denoted by date A is equal to that of date B. Seconds and milliseconds are
   * ignored.
   * Dates are represented using number of milliseconds since Jan 1, 1970 GMT.
   */


  extensions.__isTimeEqual = function (a, b) {
    if (!a || !b) {
      return false;
    }

    a = normalizeDate(a);
    b = normalizeDate(b);
    return a.getUTCHours() === b.getUTCHours() && a.getUTCMinutes() === b.getUTCMinutes();
  };

  extensions.__searchList = function (a, b) {
    //When there is only 1 item selected it is a string
    if (typeof a === 'string' && typeof b === 'string') {
      return a.toLowerCase().includes(b.toLowerCase()) || b.toLowerCase().includes(a.toLowerCase());
    } //When more than one item selected one of these is an array


    var aIsArray = Array.isArray(a);
    var bIsArray = Array.isArray(b);

    if (!(!aIsArray && bIsArray || aIsArray && !bIsArray)) {
      return false;
    }

    var query = aIsArray ? b.toLowerCase() : a.toLowerCase();
    var list = aIsArray ? a : b;
    return list.filter(function (item) {
      return item.toLowerCase().indexOf(query) >= 0;
    }).length > 0;
  }; // Entry point to extensions. Other functions are exposed for testing purposes.


  extensions.extend = function (jsonLogic) {
    if (!jsonLogic || typeof jsonLogic.add_operation !== 'function') {
      throw new Error('Unable to extend JSON Logic. Not a valid JSON logic object.');
    } // Register all of the extensions.


    jsonLogic.add_operation('datetime_after', extensions.__isDateAfter);
    jsonLogic.add_operation('datetime_before', extensions.__isDateBefore);
    jsonLogic.add_operation('datetime_equal', extensions.__isDateEqual);
    jsonLogic.add_operation('time_after', extensions.__isTimeAfter);
    jsonLogic.add_operation('time_before', extensions.__isTimeBefore);
    jsonLogic.add_operation('time_equal', extensions.__isTimeEqual);
    jsonLogic.add_operation('search_list', extensions.__searchList);
  };

  return extensions;
});